var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 93,
    height: 93,
    viewBox: "0 0 93 93",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.5039 0.25C40.4303 0.25 34.4161 1.44629 28.8048 3.77057C23.1935 6.09485 18.0949 9.5016 13.8002 13.7963C5.12666 22.4699 0.253906 34.2337 0.253906 46.5C0.253906 58.7663 5.12666 70.5301 13.8002 79.2037C18.0949 83.4984 23.1935 86.9052 28.8048 89.2294C34.4161 91.5537 40.4303 92.75 46.5039 92.75C58.7702 92.75 70.534 87.8772 79.2076 79.2037C87.8811 70.5301 92.7539 58.7663 92.7539 46.5C92.7539 40.4264 91.5576 34.4122 89.2333 28.8009C86.9091 23.1896 83.5023 18.091 79.2076 13.7963C74.9129 9.5016 69.8143 6.09485 64.203 3.77057C58.5917 1.44629 52.5775 0.25 46.5039 0.25ZM65.9289 65.925L41.8789 51.125V23.375H48.8164V47.425L69.6289 59.9125L65.9289 65.925Z",
    fill: "#1C319F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.f9b878e6cd582f3dc97f62c021d67542.svg";
export { ForwardRef as ReactComponent };